import { animateScroll as scroll } from 'react-scroll'
import React from 'react'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import { prepareData } from 'utils/googleData'
export function PricingFooterCTA(props) {
    const {
        enable,
        title,
        subtitle,
        description,
        text,
        cta,
        direction,
        style = '',
        id,
        lottie,
        gatsbyImage,
        searchParams,
    } = prepareData({
        props,
    })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <div className="flex flex-col-reverse items-center justify-center sm:flex-row sm:items-start">
            {gatsbyImage && <GatsbyImage width={252} alt={title} image={gatsbyImage} />}
            <div className="relative flex-shrink-0 rounded-md bg-[#2D2D2D] p-4 text-center sm:-mr-8 sm:rotate-6">
                <p className="m-0 font-comic text-[18px] font-bold text-white">{title}</p>
                <p className="mt-0 mb-2 font-comic text-[15px] text-white">(I’ll take you there.)</p>
                <button
                    onClick={() => scroll.scrollToTop()}
                    className="relative mx-auto flex items-center space-x-2 rounded-sm bg-red px-3 py-2 text-[15px] font-bold text-white active:top-[1px] active:scale-[.97]"
                >
                    <span>{subtitle}</span>
                    <svg width="17" height="23" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.7211 16.9033V4.24645L14.1749 6.70024C14.6354 7.14428 15.366 7.13788 15.8183 6.6865C16.2697 6.23421 16.2761 5.50358 15.832 5.04306L11.3787 0.58972C10.9209 0.132854 10.1793 0.132854 9.72153 0.58972L5.26819 5.04306C4.82415 5.50358 4.83055 6.23421 5.28284 6.6865C5.73514 7.13789 6.46576 7.14428 6.92537 6.70024L9.37729 4.24645V16.9033C9.37729 18.5989 8.00301 19.9742 6.30636 19.9742C4.61072 19.9742 3.23637 18.599 3.23637 16.9033H0.892505C0.892505 18.8379 1.92434 20.6251 3.5999 21.592C5.27447 22.5597 7.33906 22.5597 9.01375 21.592C10.6892 20.6251 11.7211 18.8379 11.7211 16.9033H11.7211Z"
                            fill="white"
                        />
                        <path d="M3.04878 15.0117V15.9493H0.70492V15.0117H3.04878Z" fill="white" />
                        <path d="M3.04878 13.1367V14.0743H0.70492V13.1367H3.04878Z" fill="white" />
                        <path d="M3.04878 7.51123V8.44878H0.70492V7.51123H3.04878Z" fill="white" />
                        <path d="M3.04878 9.38672V10.3243H0.70492V9.38672H3.04878Z" fill="white" />
                        <path d="M3.04878 11.2617V12.1993H0.70492V11.2617H3.04878Z" fill="white" />
                    </svg>
                </button>
                <svg
                    className="absolute right-2 -bottom-5 -scale-x-1 sm:left-2 sm:right-auto"
                    width="35"
                    height="29"
                    viewBox="0 0 35 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M34.0329 28.7305L28.9422 2.03952L0.169405 0.617765C0.169405 0.617765 12.4378 8.50347 18.738 13.9774C25.0381 19.4513 34.0329 28.7305 34.0329 28.7305Z"
                        fill="#2D2D2D"
                    />
                </svg>
            </div>
        </div>
    )
}
export default PricingFooterCTA
